import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { List } from 'antd';

import ChannelListItem from './ChannelListItem';
import i18n from '../../config/i18n';
import { PATIENT_ID } from '../../constants/RoleConstants';

const THEME_LIGHT_COLOR = '#ecf0f1';
const THEME_DARK_COLOR = '#2d3e4f';

const Container = styled.div`
  background-color: ${THEME_LIGHT_COLOR};
`;

const Header = styled.div`
  min-height: 60px;
  background-color: ${THEME_DARK_COLOR};
  color: white;
  display: flex;
  justify-content: space-between;
`;

const NoRowsContent = styled.div`
  position: absolute;
  top: 60px;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #bdbdbd;
`;

const HeaderContent = styled.p`
  font-weight: bold;
  font-size: 17px;
  margin: auto 15px;
`;

const AddButton = styled.button`
  height: 36px;
  width: 36px;
  border-radius: 50%;
  background-color: ${THEME_DARK_COLOR};
  color: white;
  border: none;
  font-size: 24px;
`;

const styles = {
  list: {
    position: 'absolute',
    top: '60px',
    bottom: 0,
    left: 0,
    right: 0,
    overflowY: 'scroll',
  },
  buttonWrapper: {
    bottom: '48px',
    height: 0,
    position: 'absolute',
    textAlign: 'center',
    width: '100%',
  },
};


const ChannelList = ({
  channels,
  className,
  currentChannelId,
  currentUserRoleId,
  onCheckOutChannel,
  onCreateChannel,
}) => {
  const handleClickCreate = (e) => {
    e.preventDefault();
    onCreateChannel();
  };

  const handleClickItem = (channelId) => {
    if (channelId !== currentChannelId) onCheckOutChannel(channelId);
  };

  const renderListItems = item => (
    <ChannelListItem
      channel={item}
      onClick={handleClickItem}
      selected={item.id === currentChannelId}
      highlight={item.hasPatient && currentUserRoleId !== PATIENT_ID}
    />
  );

  return (
    <Container className={className}>
      <Header>
        <HeaderContent>
          {i18n.t('channels')}
        </HeaderContent>
      </Header>
      {
        _.isEmpty(channels) ? (
          <NoRowsContent>
            {i18n.t('noChannel')}
          </NoRowsContent>
        ) : (
          <List
            dataSource={channels}
            renderItem={renderListItems}
            style={styles.list}
          />
        )
      }
      {
        currentUserRoleId !== PATIENT_ID && (
          <div style={styles.buttonWrapper}>
            <AddButton
              onClick={handleClickCreate}
            >
              +
            </AddButton>
          </div>
        )
      }
    </Container>
  );
};

ChannelList.propTypes = {
  channels: PropTypes.array,
  className: PropTypes.string,
  currentChannelId: PropTypes.number,
  currentUserRoleId: PropTypes.number,
  onCheckOutChannel: PropTypes.func.isRequired,
  onCreateChannel: PropTypes.func.isRequired,
};

ChannelList.defaultProps = {
  channels: [],
  className: '',
  currentChannelId: undefined,
  currentUserRoleId: undefined,
};


export default ChannelList;



// WEBPACK FOOTER //
// ./src/components/messaging/ChannelList.js